<template>
  <div class="c c-empty-state">
    <span class="h4">
      {{ title }}
    </span>
    <p class="mb-0">
      {{ text }}
    </p>
    <a :href="url" class="btn btn-outline-grey reveal-icon" :title="linkText">
      <span>
        {{ linkText }}
      </span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'NoResults',
  props: {
    title: {
      type: String,
      default: 'No results found'
    },
    text: {
      type: String,
      default:
        "We couldn't find any results. Change your chosen filters or contact us"
    },
    url: {
      type: String,
      default: '/contact'
    },
    linkText: {
      type: String,
      default: 'Contact us'
    }
  }
};
</script>

<style lang="scss" scoped>
.c-empty-state {
  margin-top: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .btn {
    margin-top: 30px;
  }
}
</style>
